module.exports = "<div seedelement><span class=\"text\"><slot></slot></span></div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-button/theme/lui-button.html
// module id = 180
// module chunks = 0 1 18